import { supabase } from '../../../src/lib/supabase';

export async function registrarTransferenciaAncora(params: {
  rateioUnidadeGeradoraId: string;
  unidadeConsumidoraDestinoId: number;
  montanteKwh: number;
  dataRetornoAgendada: string;
}): Promise<string> {
  const { data, error } = await supabase.rpc('registrar_transferencia_ancora', {
    p_rateio_unidade_geradora_id: params.rateioUnidadeGeradoraId,
    p_unidade_consumidora_destino_id: params.unidadeConsumidoraDestinoId,
    p_montante_kwh: params.montanteKwh,
    p_data_retorno_agendada: params.dataRetornoAgendada,
  });
  if (error) throw error;
  return data as string;
}

export async function retornarTransferenciaAncora(transferenciaId: string): Promise<void> {
  const { error } = await supabase.rpc('retornar_transferencia_ancora', { p_transferencia_id: transferenciaId });
  if (error) throw error;
}
